export const Table = ({
    displayedData,
    currentPage,
    itemsPerPage,
    filteredData,
    handleNextPage,
    handlePrevPage,
    totalPages,
    onUserEdit,
    onUserDelete,
}) => {
    return (
        <>
            <div className="overflow-auto rounded shadow-md p-4">
                <table className="w-full border-collapse table-auto">
                    <thead className="bg-blue-100">
                        <tr>
                            <th className="px-4 py-3 text-center text-sm font-medium text-gray-700">
                                #
                            </th>
                            <th className="px-4 py-3 text-center text-sm font-medium text-gray-700">
                                Username
                            </th>
                            <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
                                Nama Lembaga
                            </th>
                            <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
                                Password
                            </th>
                            <th className="px-4 py-3 text-left text-sm font-medium text-gray-700">
                                Aksi
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {displayedData.map((data, i) => (
                            <tr
                                key={i}
                                className="hover:bg-slate-50 border-b border-slate-200">
                                <td className="p-2 py-3 text-center">
                                    {(currentPage - 1) * itemsPerPage + i + 1}
                                </td>
                                <td className="p-2 py-3 text-center">
                                    {data.username}
                                </td>
                                <td className="p-2 py-3">
                                    {data.school_name || "-"}
                                </td>
                                <td className="p-2 py-3">{data.password}</td>
                                <td className="p-2 py-3 flex flex-row gap-1 whitespace-nowrap">
                                    <button
                                        onClick={() => onUserEdit(data)}
                                        className="flex gap-1 flex-row items-center justify-between px-1.5 py-0.1 text-white rounded bg-blue-500 hover:bg-blue-600 ">
                                        <span className="text-sm material-symbols-outlined">
                                            edit
                                        </span>
                                        edit
                                    </button>
                                    <button
                                        onClick={() => onUserDelete(data.id)}
                                        className="flex gap-1 flex-row items-center justify-between px-1.5 py-0.1 text-white rounded bg-red-500 hover:bg-red-600 ">
                                        <span className="text-sm material-symbols-outlined">
                                            delete
                                        </span>
                                        delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="flex justify-between items-center px-4 py-3">
                <div className="text-sm text-slate-500">
                    <b>{(currentPage - 1) * itemsPerPage + 1}</b> -{" "}
                    <b>
                        {Math.min(
                            currentPage * itemsPerPage,
                            filteredData.length
                        )}
                    </b>{" "}
                    of <b>{filteredData.length}</b>
                </div>
                <div className="flex space-x-1">
                    <button
                        onClick={handlePrevPage}
                        className="px-3 py-1 text-sm font-normal text-slate-500 bg-white border border-slate-200 rounded hover:bg-slate-50 hover:border-slate-400"
                        disabled={currentPage === 1}>
                        Prev
                    </button>
                    <button
                        onClick={handleNextPage}
                        className="px-3 py-1 text-sm font-normal text-slate-500 bg-white border border-slate-200 rounded hover:bg-slate-50 hover:border-slate-400"
                        disabled={currentPage === totalPages}>
                        Next
                    </button>
                </div>
            </div>
        </>
    );
};
